// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ReviewGen App Styles */

.review-card {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.review-card:hover {
    transform: translateY(-4px);
}

.review-card.selected {
    ring: 2px;
}

/* Hero gradient overlay */
.hero-gradient {
    background: linear-gradient(135deg, rgba(248, 250, 252, 0.95) 0%, rgba(248, 250, 252, 0.85) 100%);
}

/* Glass effect for action bar */
.glass-bar {
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
}

/* Loading shimmer effect */
@keyframes shimmer {
    0% {
        background-position: -200% 0;
    }
    100% {
        background-position: 200% 0;
    }
}

.skeleton-shimmer {
    background: linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%);
    background-size: 200% 100%;
    animation: shimmer 1.5s infinite;
}

/* Copy button pulse */
@keyframes pulse-ring {
    0% {
        transform: scale(0.9);
        opacity: 1;
    }
    100% {
        transform: scale(1.3);
        opacity: 0;
    }
}

.copy-pulse::after {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: inherit;
    background: currentColor;
    opacity: 0.3;
    animation: pulse-ring 0.5s ease-out;
}

/* Smooth page transitions */
.page-enter {
    opacity: 0;
    transform: translateY(20px);
}

.page-enter-active {
    opacity: 1;
    transform: translateY(0);
    transition: opacity 0.3s ease, transform 0.3s ease;
}

/* Custom brand color injection via CSS variables */
[data-brand-color] {
    --brand-primary: attr(data-brand-color);
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,yBAAyB;;AAEzB;IACI,iDAAiD;AACrD;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,SAAS;AACb;;AAEA,0BAA0B;AAC1B;IACI,iGAAiG;AACrG;;AAEA,gCAAgC;AAChC;IACI,2BAA2B;IAC3B,mCAAmC;AACvC;;AAEA,2BAA2B;AAC3B;IACI;QACI,4BAA4B;IAChC;IACA;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI,yEAAyE;IACzE,0BAA0B;IAC1B,gCAAgC;AACpC;;AAEA,sBAAsB;AACtB;IACI;QACI,qBAAqB;QACrB,UAAU;IACd;IACA;QACI,qBAAqB;QACrB,UAAU;IACd;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,sBAAsB;IACtB,wBAAwB;IACxB,YAAY;IACZ,mCAAmC;AACvC;;AAEA,4BAA4B;AAC5B;IACI,UAAU;IACV,2BAA2B;AAC/B;;AAEA;IACI,UAAU;IACV,wBAAwB;IACxB,kDAAkD;AACtD;;AAEA,mDAAmD;AACnD;IACI,uCAAuC;AAC3C","sourcesContent":["/* ReviewGen App Styles */\n\n.review-card {\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.review-card:hover {\n    transform: translateY(-4px);\n}\n\n.review-card.selected {\n    ring: 2px;\n}\n\n/* Hero gradient overlay */\n.hero-gradient {\n    background: linear-gradient(135deg, rgba(248, 250, 252, 0.95) 0%, rgba(248, 250, 252, 0.85) 100%);\n}\n\n/* Glass effect for action bar */\n.glass-bar {\n    backdrop-filter: blur(12px);\n    -webkit-backdrop-filter: blur(12px);\n}\n\n/* Loading shimmer effect */\n@keyframes shimmer {\n    0% {\n        background-position: -200% 0;\n    }\n    100% {\n        background-position: 200% 0;\n    }\n}\n\n.skeleton-shimmer {\n    background: linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%);\n    background-size: 200% 100%;\n    animation: shimmer 1.5s infinite;\n}\n\n/* Copy button pulse */\n@keyframes pulse-ring {\n    0% {\n        transform: scale(0.9);\n        opacity: 1;\n    }\n    100% {\n        transform: scale(1.3);\n        opacity: 0;\n    }\n}\n\n.copy-pulse::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    border-radius: inherit;\n    background: currentColor;\n    opacity: 0.3;\n    animation: pulse-ring 0.5s ease-out;\n}\n\n/* Smooth page transitions */\n.page-enter {\n    opacity: 0;\n    transform: translateY(20px);\n}\n\n.page-enter-active {\n    opacity: 1;\n    transform: translateY(0);\n    transition: opacity 0.3s ease, transform 0.3s ease;\n}\n\n/* Custom brand color injection via CSS variables */\n[data-brand-color] {\n    --brand-primary: attr(data-brand-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
